import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "Frame6"
});
const _hoisted_1 = {
  width: "14",
  height: "18",
  viewBox: "0 0 14 18",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  "fill-rule": "evenodd",
  "clip-rule": "evenodd",
  d: "M12.7633 17.2333H1.23666C0.781949 17.2333 0.41333 16.8647 0.41333 16.41V1.59C0.41333 1.13528 0.781949 0.766663 1.23666 0.766663H9.46999L13.5867 4.92519V16.41C13.5867 16.8647 13.218 17.2333 12.7633 17.2333ZM8.31651 6.07588C8.06491 5.84566 7.67432 5.86299 7.4441 6.11459C7.21387 6.36619 7.2312 6.75678 7.4828 6.98701L8.55958 7.9723H3.60815C3.40105 7.9723 3.23315 8.14019 3.23315 8.3473V8.8323C3.23315 9.03941 3.40105 9.2073 3.60815 9.2073H10.1491C10.247 9.2073 10.3396 9.18451 10.4219 9.14394C10.476 9.11732 10.5269 9.08235 10.5727 9.03912C10.6081 9.00576 10.6395 8.96827 10.6662 8.92743C10.7297 8.83039 10.7666 8.71441 10.7666 8.5898C10.7666 8.50122 10.748 8.41699 10.7144 8.34083C10.6809 8.26464 10.6313 8.19401 10.566 8.13421L8.31651 6.07588ZM3.23315 11.2163C3.23315 11.1343 3.24917 11.0559 3.27823 10.9843C3.29878 10.9336 3.32639 10.885 3.36112 10.8399C3.37552 10.8212 3.39097 10.8033 3.40738 10.7864C3.46356 10.7284 3.52853 10.6838 3.59827 10.6526C3.67532 10.618 3.76074 10.5988 3.85065 10.5988H3.85108H10.3916C10.5987 10.5988 10.7666 10.7667 10.7666 10.9738V11.4588C10.7666 11.6659 10.5987 11.8338 10.3916 11.8338H5.44021L6.51697 12.8191C6.76857 13.0493 6.7859 13.4399 6.55567 13.6915C6.32545 13.9431 5.93486 13.9604 5.68326 13.7302L3.43543 11.6734L3.4265 11.6651C3.36499 11.607 3.31801 11.5391 3.28577 11.4661C3.25194 11.3898 3.23315 11.3052 3.23315 11.2163Z",
  fill: "#42526E"
}, null, -1);
const _hoisted_3 = /* @__PURE__ */ createElementVNode("path", {
  opacity: "0.3",
  d: "M9.46509 4.33362C9.46552 4.48959 9.52857 4.63905 9.64047 4.74936C9.75237 4.85966 9.90402 4.92185 10.0623 4.92233H13.5866L9.46509 0.766663V4.33362Z",
  fill: "white"
}, null, -1);
const _hoisted_4 = [
  _hoisted_2,
  _hoisted_3
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_4);
}
var Frame_6 = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { Frame_6 as default };
